
export default {
    components: {},
    name: 'index',
    head() {
        // 优化seo：动态设置title，keywords 和 description
        return {
            title: this.source.info.title,
            meta: [
                {
                    name: "keywords",
                    content:
                        this.source.info.title,
                },
                {
                    name: 'description', content: this.source.info.title
                },
            ],
        };
    },
    data() {
        return {
            source: {
                info: {
                    title: ''
                }
            },
        };
    },
    async asyncData({ $global, params, error }) {
        const res = await $global.newsDetail({ id: params.id })
        if (res.code == 200) {
            return { source: res.data }
        } else {
            error({ statusCode: 500 })
        }
    },
    mounted() {
        // this.getData()
        /** hwtag埋点-阅读*/
        this.$track('content_viewed', {
            'content_id': this.source.info.id,
            'content_type': 'news',
            'author_id': '00001',
            'author':'xppen',
            'current_view':this.source.info.hits,
        });

    },
    watchQuery: ['t'],
    methods: {
        async getData() {
            let res = await this.$global.newsDetail({ id: this.$route.params.id })
            res.code == 200 ? this.source = res.data : ''
        },
        async collectOperation() {
            //收藏 取消收藏
            //type 1作品收藏 3资讯收藏 5活动收藏 9帖子收藏 10教程收藏
            //is_collect 0是收藏1取消收藏
            let res = await this.$global.do_collect({ "relation_id": this.source.info.id, "type": "3", "is_collect": Number(this.source.info.is_collect) })
            console.log(res, 'res')
            if (res.code == 200) {
                this.getData()
                this.$message({
                    showClose: true,
                    message: res.msg
                });

            }


        }
    }

}
